import { DashboardColumn, DashboardRow, GtSummaryResponseDto, QuestionResponseDto } from "./Dashboard.Type";
import FormatHelper from "../../Utility/FormatHelper";

export const transformDashboardRows = (
    data: GtSummaryResponseDto[]
): DashboardRow[] => {

    return (data ?? []).map((item) => {

        const answerMap: Record<string, string> = {};

        item.answers?.forEach((answer) => {

            answerMap[answer.questionId] =
                answer.answers?.join(", ") || "";

        });

        return {

            gtId: item.gtId,
            visitId: item.visitId,
            gtName: item.gtName,
            year: item.year,
            state: item.state,
            territory: item.territory,
            district: item.district,
            completedBy: item.completedBy,
            createdAt: item.createdAt,
            polygonCordinates: item.polygonCordinates,

            answerMap

        };

    });

};

export const buildDashboardColumns = (
    questions: QuestionResponseDto[]
): DashboardColumn[] => {

    const staticColumns: DashboardColumn[] = [

        {
            key: "gtName",
            header: "GT Name",
            isStatic: true
        },
        {
            key: "gtId",
            header: "GT ID",
            isStatic: true
        },
        {
            key: "visitId",
            header: "Visit ID",
            isStatic: true
        },
        {
            key: "year",
            header: "Year",
            isStatic: true
        },
        {
            key: "state",
            header: "State",
            isStatic: true
        },
        {
            key: "territory",
            header: "Territory",
            isStatic: true
        },
        {
            key: "district",
            header: "District",
            isStatic: true
        },
        {
            key: "completedBy",
            header: "Completed By",
            isStatic: true
        },
        {
            key: "createdAt",
            header: "Created At",
            isStatic: true
        },
        {
            key: "polygonCordinates",
            header: "Polygon Coordinates",
            isStatic: true
        }

    ];

    const dynamicColumns: DashboardColumn[] = (questions ?? []).map((q) => ({

        key: q.questionId,

        header: q.questionText,

        isStatic: false,

        controlType: q.controlType,

    }));

    return [

        ...staticColumns,

        ...dynamicColumns

    ];

};

export const getCellValue = (
    row: DashboardRow,
    column: DashboardColumn
): React.ReactNode => {

    let value: any;
    if (row && column?.key && column.key in row) {

        value = row[column.key as keyof Omit<DashboardRow, "answerMap">];
    }
    else {

        value = row?.answerMap?.[column?.key] ?? "-";
    }
    if (value === null || value === undefined || value === "") {
        return "-";
    }

    if (column.controlType === "calendar") {
        const date = new Date(value);
        return date.toLocaleDateString("en-gb");
    }
    if (column.key === "createdAt") {
        return FormatHelper.dateHandler({ date: value, format: "dd/MM/yyyy" });
    }
    if (column.controlType === "image") {
        return (
            value
        );
    }
    if (column.controlType === "multiple_dropdown") {
        if (Array.isArray(value)) {
            return value.join(", ");
        }
        return value;
    }
    return String(value);
};